import React, { useState, useEffect, useRef } from 'react';
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet'

import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import AlertModal from '../partials/AlertModal'
import DateSelect from '../partials/actions/DateSelect'
import ComposeNotiCard from '../partials/compose/ComposeNotiCard'

import { Auth, API, graphqlOperation } from 'aws-amplify';

function Compose() {

  let history = useHistory();
  const location = useLocation()
  const search = location.search;

  const categories = ['Select market',
    'General',
    'Art & Design',
    'Books & Reference',
    'Business',
    'Comics',
    'Education',
    'Entertainment',
    'Events',
    'Finance',
    'Food & Drink',
    'Games',
    'Health & Fitness',
    'Lifestyle',
    'Medical',
    'Music & Audio',
    'News & Magazines',
    'Shopping',
    'Social',
    'Sports',
    'Strategy',
    'Travel & Local']

  const [ authToken, setAuthToken ] = useState(null)
  const [loadingVisible, setLoadingVisible] = useState(false);
  const [ userDetails, setUserDetails ] = useState(null)
  const [ targetMarket, setTargetMarket ] = useState({id: 0, name: categories[0]})
  const [ campaignMessage, setCampaignMessage ] = useState('')
  const [ numRequests, setNumRequests ] = useState(20)

  const messageInputRef = useRef()

  const [ genNotiList, setGenNotiList ] = useState([])



  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [authSession, setAuthSession] = useState(null)
  const [alertModalState, setAlertModalState] = useState(null)

  useEffect(() => {
    OnLoad();
  }, []);

  function OnLoad() {
    Auth.currentSession().then(response => {
      setAuthToken(response.idToken.jwtToken)
    }).catch( (error) => {
      history.push('/signin')
    });

    if(location!=null) {
      if(location.state==null) {
        history.push('/signin')
      }
      else{
        setUserDetails(location.state.userDetails)
        if('queryParams' in location.state) {
          /*if(location.state.queryParams === 'n=ready')
            setAlertModalState({title: '🎉 Insights Ready', message: 'Insights for your synced integration ✔️ are ready. Check them out now 👀'})*/
        }
      }
    }
    else {
      history.push('/signin')
    }
  }

  async function marketChange(market){
    if(market.name==='Select market')
      return
    setTargetMarket(market)
    setCampaignMessage('')
    if(authToken!=null) {

      if(numRequests<1){
        setAlertModalState({title: 'Limit Reached!', message: 'Sorry, you have hit the limit for this feature. Come back later or subscribe!'})
        messageInputRef.current.setAttribute("disabled", true);
        return
      }
      else {
        setNumRequests(numRequests - 1)

        setLoadingVisible(true)

        const apiName = 'DashboardAPI';
        const path = '/nlp/compose';
        const params = {
          body: {
            category: market.name,
            prompt: ''
          },
          headers: {
            Authorization: `Bearer ${authToken}`
          },
        };

        API
          .post(apiName, path, params)
          .then(response => {
            setGenNotiList(response.filter((item) => {
              return item != '';
            }).map((item) =>
              <div className="flex-1 m-0">
                <ComposeNotiCard text={item} market={market.name}/>
              </div>
            ));
            setLoadingVisible(false)
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
            setLoadingVisible(false)
            setAlertModalState({title: 'Oops!', message: 'Something went wrong.'})
          });
      }
    }
  }

  async function messageChange(event){

    var text = event.target.value
    setCampaignMessage(text)
    if(text!=null && text!=undefined && text.trim()!='' && text.trim().split(' ').length > 2
       && text[text.length -1]==' ' && authToken!=null){

      if(numRequests<1){
        setAlertModalState({title: 'Limit Reached!', message: 'Sorry, you have hit the limit for this feature. Come back later or subscribe!'})
        messageInputRef.current.setAttribute("disabled", true);
        return
      }
      else {
        setNumRequests(numRequests - 1)

        setLoadingVisible(true)

        const apiName = 'DashboardAPI';
        const path = '/nlp/compose';
        const params = {
          body: {
            category: targetMarket.name,
            prompt: text
          },
          headers: {
            Authorization: `Bearer ${authToken}`
          },
        };

        API
          .post(apiName, path, params)
          .then(response => {
            setGenNotiList(response.map((item) =>
              <div className="flex-1 m-0">
                <ComposeNotiCard text={item} market={targetMarket.name}/>
              </div>
            ));
            setLoadingVisible(false)
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
            setLoadingVisible(false)
            setAlertModalState({title: 'Oops!', message: 'Something went wrong.'})
          });
      }
    }
  }

  return userDetails!=null?(
      <div className="flex h-screen overflow-hidden striped-background-pattern">
        {/* Page Title */}
        <Helmet>
          <title>EmPushy | Compose</title>
        </Helmet>

        {/* Sidebar */}
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>

        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

          {/*  Site header */}
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>

          <main>
            <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">

              {/* Page header */}
              <div className="mb-5">
                {/* Title */}
                <h1 className="text-2xl md:text-3xl text-gray-800 font-bold">EmPushy Compose 📝</h1>
              </div>

              {/* Search form */}
              <div className="w-8/12 mb-5">
                <div className="flex">
                  <div className="mr-4">
                    <label className="block text-sm font-medium mb-1" htmlFor="subject">Target Market</label>
                    <DateSelect options={
                      categories.map((cat, i) => ({id: i, name: cat}))
                    } onChange={marketChange} />
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm font-medium mb-1" htmlFor="subject">Campaign Message</label>
                    <textarea id="app-search" className="form-input w-full pl-3 py-3 focus:border-gray-300 disabled:opacity-50" value={campaignMessage}
                              placeholder="Our new sale launches today, don't miss out!" onChange={messageChange}
                              ref={messageInputRef}/>
                  </div>
                </div>
              </div>

              {/* Filters */}
              <div className="mb-4 border-b border-gray-300">
                {/*<ul className="text-sm font-medium flex flex-nowrap -mx-4 sm:-mx-6 lg:-mx-8 overflow-x-scroll no-scrollbar">
                  {activeIntegrations.length>0?<li
                    className="pb-3 mr-6 last:mr-0 first:pl-4 sm:first:pl-6 lg:first:pl-8 last:pr-4 sm:last:pr-6 lg:last:pr-8">
                    <button className="text-gray-500 hover:text-gray-600 whitespace-nowrap"
                            onClick={() => selectedTab('overview', null)}>📊 Overview
                    </button>
                  </li>:''}
                  {activeIntegrationsHTML}
                  <li className="pb-3 mr-6 last:mr-0 first:pl-4 sm:first:pl-6 lg:first:pl-8 last:pr-4 sm:last:pr-6 lg:last:pr-8">
                    <button className="text-gray-500 hover:text-gray-600 whitespace-nowrap" onClick={() => selectedTab('add', null)}>⚙️ Sync Settings</button>
                  </li>
                </ul>*/}
              </div>

              {/* Page content */}
              <div className="flex">
                {loadingVisible?<div className="sm:flex justify-items-center mt-5 w-full">
                    <div className="m-auto">
                      <svg className="animate-spin h-8 w-8" viewBox="0 0 100 100">
                        <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="10" fill="transparent" strokeLinecap="round"
                                strokeDasharray="283" strokeDashoffset="75"/>
                      </svg>
                    </div>
                </div>:genNotiList.length>0?<div className="grid grid-cols-2 gap-1 max-h-full w-full p-0 m-0 overflow-y-scroll text-center">{genNotiList}</div>:
                <ul>
                  <li><span className="mr-5">☝️</span>Select a Target Market for your notification</li>
                  <li><span className="mr-3">✨</span>Campaign messages which align with your selected target market will be displayed here 📍</li>
                  <li><span className="mr-3">✍️</span>If you have a particular message in mind, start typing it above and the suggested content will be tailored to your message</li>
                </ul>}
              </div>

              {/*<div>

               Cards 1 (Trending apps)
              <div className="mt-8">
                <h2 className="text-xl text-gray-800 font-bold mb-5">Trending apps</h2>
                <div className="grid grid-cols-12 gap-6">
                {
                  items01.map(item => {
                    return (
                      <ApplicationsCard01
                        key={item.id}
                        id={item.id}
                        image={item.image}
                        title={item.title}
                        link={item.link}
                        content={item.content}
                        rating={item.rating}
                        feat01={item.feat01}
                        feat02={item.feat02}
                        feat03={item.feat03}
                        feat04={item.feat04}
                      />
                    )
                  })
                }
                </div>
              </div>

               Cards 2 (Premium but worth it)
              <div className="mt-8">
                <h2 className="text-xl text-gray-800 font-bold mb-5">Premium but worth it</h2>
                <div className="grid grid-cols-12 gap-6">
                {
                  items02.map(item => {
                    return (
                      <ApplicationsCard02
                        key={item.id}
                        id={item.id}
                        image={item.image}
                        title={item.title}
                        link={item.link}
                        content={item.content}
                        rating={item.rating}
                        price={item.price}
                        deal={item.deal}
                      />
                    )
                  })
                }
                </div>
              </div>

               Cards 3 (Popular categories)
              <div className="mt-8">
                <h2 className="text-xl text-gray-800 font-bold mb-5">Popular categories</h2>
                <div className="grid grid-cols-12 gap-6">
                {
                  items03.map(item => {
                    return (
                      <ApplicationsCard03
                        key={item.id}
                        id={item.id}
                        image={item.image}
                        title={item.title}
                        link={item.link}
                      />
                    )
                  })
                }
                </div>
              </div>

            </div>*/}

            </div>
            <AlertModal params={alertModalState} toggleState={setAlertModalState}/>
          </main>
        </div>
      </div>
  ):'';
}

export default Compose;